import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

import styles from "./Banner.module.scss";

export const Banner = () => {
  return (
    <div className={styles.sliderContainer}>
      <Swiper
        modules={[Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
      >
        <SwiperSlide>
          <a href="/lojas/69777011-e4ed-4dd5-a68d-5c7a37f78127" target="_blank" rel="noopener noreferrer">
            <img
              src="/imagens/AltoEstilo.png"
              alt="Banner 1"
              className={styles.banner}
            />
          </a>
        </SwiperSlide>

        <SwiperSlide>
          <a href="/lojas/6c72523b-2263-4b75-8ac1-262f26c87627" target="_blank" rel="noopener noreferrer">
            <img
              src="/imagens/MKMTenis.jpeg"
              alt="Banner 2"
              className={styles.banner}
            />
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href="/lojas/45faa253-1a42-46fe-862f-4ce4e74927a4" target="_blank" rel="noopener noreferrer">
            <img
              src="/imagens/MinhaFarma.jpeg"
              alt="Banner 3"
              className={styles.banner}
            />
          </a>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};